<template>
  <div
    id="password-modal"
    class="modal fade"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('パスワード設定') }}</h5>
        </div>
        <div class="modal-body">
          <p>結果を閲覧するためにパスワードを設定してください。</p>
          <label class="mt-3">{{ $t('パスワード') }}</label>
          <div class="form-row">
            <div class="form-group col-12">
              <input
                v-model="form.password"
                type="password"
                autocomplete="off"
                class="form-control"
                :class="{ 'is-invalid': validations.password.message !== '' }"
              />
              <div class="invalid-feedback">
                {{ validations.password.message }}
              </div>
              <span>※英大文字・英小文字・数字・記号を含む８文字以上</span>
            </div>
          </div>
          <label class="mt-3">{{ $t('パスワードの確認') }}</label>
          <div class="form-row">
            <div class="form-group col-12">
              <input
                v-model="form.passwordConfirmation"
                type="password"
                autocomplete="off"
                class="form-control"
                :class="{
                  'is-invalid': validations.passwordConfirmation.message !== ''
                }"
              />
              <div class="invalid-feedback">
                {{ validations.passwordConfirmation.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary" @click="handleOk">OK</button>
        </div>
      </div>
    </div>
    <div
      class="toast-container position-fixed top-0 start-50 translate-middle-x"
    >
      <div
        id="password-save-success"
        class="toast"
        auto-hide-delay="2000"
        toaster="b-toaster-top-center"
      >
        <div class="toast-body">
          <div class="alert alert-success mb-0">
            {{ $t('保存しました。') }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="toast-container position-fixed top-0 start-50 translate-middle-x"
    >
      <div
        id="password-save-error"
        class="toast"
        auto-hide-delay="2000"
        toaster="b-toaster-top-center"
      >
        <div class="toast-body">
          <div class="alert alert-warning mb-0">
            {{ $t('保存に失敗しました。入力内容を確認してください。') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import { useUser } from '~/composables/user';
import { useBootstrap } from '~/composables/bootstrap';
import { updateCurrentUserPassword } from '~/models/user/api';
import { mapToValidationError, toValidationMessage } from '~/types/validation';

export default defineComponent({
  components: {},

  data() {
    return {
      form: {
        password: '',
        passwordConfirmation: ''
      },

      validations: {
        password: {
          name: this.$t('パスワード'),
          data: {},
          message: ''
        },
        passwordConfirmation: {
          name: this.$t('パスワードの確認'),
          data: {},
          message: ''
        }
      } as {
        [key: string]: {
          name: string;
          data: { [key: string]: string };
          message: string;
        };
      }
    };
  },

  computed: {
    profile() {
      const { profile } = useUser();
      return profile;
    }
  },

  mounted() {
    // パスワード未設定のときに表示する
    if (!this.profile.passwordRegistered) 
    {
      const { showModal } = useBootstrap();
      showModal('password-modal');
    }
  },

  methods: {
    async handleOk(e: Event) {
      e.preventDefault();

      // this.isSaving = true;
      for (const k in this.validations) {
        this.validations[k].message = '';
      }
      
      await updateCurrentUserPassword(this.$userServiceAxios, this.form)
        .then((r: any) => {
          if (r.data.updated) {
            const { hideModal } = useBootstrap();
            hideModal('password-modal');
          }
        })
        .catch((e: any) => {
          const { showToast } = useBootstrap();
          showToast('password-save-error');
          const v = mapToValidationError(e.data);
          // バリデーションのメッセージ作成
          for (const key in v) {
            this.validations[key].message = toValidationMessage(
              this.$t(`validation.${v[key].no}`).toString(),
              this.validations[key].name,
              v[key].data
            );
          }
        });
      // this.isSaving = false;
    }
  }
});
</script>
